import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "recent-instagram-followers-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "p-0 m-0 list-unstyled" }
const _hoisted_5 = { class: "user d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-block fw-medium text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"trezo-card-header d-flex align-items-center justify-content-between\" data-v-cf22b21e><div class=\"trezo-card-title\" data-v-cf22b21e><h5 class=\"mb-0 fw-semibold\" data-v-cf22b21e>Recent Instagram Followers</h5><p class=\"fw-normal\" data-v-cf22b21e>Check out your latest followers</p></div><div class=\"trezo-card-subtitle\" data-v-cf22b21e><div class=\"trezo-card-header-menu position-relative\" data-v-cf22b21e><div class=\"dropdown action-opt\" data-v-cf22b21e><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-cf22b21e><i class=\"ri-more-2-fill\" data-v-cf22b21e></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-cf22b21e><li data-v-cf22b21e><button class=\"dropdown-item\" data-v-cf22b21e>This Day</button></li><li data-v-cf22b21e><button class=\"dropdown-item\" data-v-cf22b21e>This Week</button></li><li data-v-cf22b21e><button class=\"dropdown-item\" data-v-cf22b21e>This Month</button></li><li data-v-cf22b21e><button class=\"dropdown-item\" data-v-cf22b21e>This Year</button></li></ul></div></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followers, (follower, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "d-flex align-items-center justify-content-between"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: follower.image,
                  class: "rounded-circle",
                  alt: "user-image"
                }, null, 8, _hoisted_6),
                _createElementVNode("span", _hoisted_7, _toDisplayString(follower.name), 1)
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "action d-flex align-items-center" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "follow-btn d-inline-block border-0"
                }, " Follow Back "),
                _createElementVNode("button", {
                  type: "button",
                  class: "message-btn d-flex align-items-center justify-content-center border-0 p-0"
                }, [
                  _createElementVNode("i", { class: "ri-message-2-line" })
                ])
              ], -1))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}